import React from 'react';
// import PropTypes from 'prop-types';
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {useStyles } from './../Complements/usesStyles'


const MainSimple = props => {
    const {  body } = props
    const classes = useStyles(props);
    return (
        <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                { body }
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    );
};

/* MainSimple.propTypes = {
    
}; */

export default MainSimple;